class ShareButton extends window.BAO.DetailsDisclosure {
  static get requiredElements () {
    return super.requiredElements.concat([
      'trigger',
      'message',
      'input',
      'copy',
    ])
  }

  connectedCallback () {
    super.connectedCallback()

    this.urlToShare = this.els.input.element.value
      ? this.els.input.element.value
      : document.location.href

    if (navigator.share) {
      this.els.details.element.setAttribute('hidden', '')
      this.els.trigger.element.removeAttribute('hidden')
    }
  }

  setupListeners () {
    super.setupListeners()

    if (navigator.share) {
      this.listeners.add(this.els.trigger.element, 'click', () => {
        navigator.share({
          url: this.urlToShare,
          title: document.title,
        })
      })
    } else {
      this.onToggle = this.onToggle.bind(this)
      this.listeners.add(this.els.details.element, 'toggle', this.onToggle)

      this.copyToClipboard = this.copyToClipboard.bind(this)
      this.listeners.add(this.els.copy.element, 'click', this.copyToClipboard)

      this.listeners.add(this.els.close.element, 'click', this.close)
    }
  }

  onToggle () {
    if (!this.els.details.element.open) {
      this.els.message.element.classList.add('util-ScreenReaderOnly')
      this.els.message.element.textContent = ''

      this.els.close.element.setAttribute('hidden', '')
      this.els.summary.element.focus()

      this.els.copy.element.removeAttribute('hidden')
    }
  }

  copyToClipboard () {
    navigator.clipboard.writeText(this.els.input.element.value).then(() => {
      this.els.message.element.classList.remove('util-ScreenReaderOnly')
      this.els.message.element.textContent =
        this.els.message.element.dataset.successMessage

      this.els.close.element.removeAttribute('hidden')
      this.els.close.element.focus()

      this.els.copy.element.setAttribute('hidden', '')
    })
  }

  updateUrl (url) {
    this.urlToShare = url
    this.els.input.element.value = url
  }
}

customElements.define('share-button', ShareButton)
